import {FC} from 'react';

type Icon = {
    className?: string;
};

const Key: FC<Icon> = ({className}) => (
    <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path
            d="M15.662 8.494c1.749-1.749 1.788-4.544.088-6.244-1.7-1.7-4.495-1.66-6.244.088a4.5 4.5 0 0 0-1.203 4.281l-6.784 6.784c-.32.32-.503.753-.51 1.206L1 15.266a1.71 1.71 0 0 0 3.382.381l.037-.172a1.741 1.741 0 0 1 1.34-1.34l.4-.085a1.741 1.741 0 0 0 1.34-1.34l.086-.4a1.741 1.741 0 0 1 1.34-1.34l1.001-.214c.329-.07.63-.234.868-.472l.587-.587a4.5 4.5 0 0 0 4.281-1.203Z"
            stroke="#F4F6FC"
        />
        <circle cx="20.4444" cy="11.5556" r="0.888889" fill="#C5CDF8" />
    </svg>
);

export default Key;
